import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'fidelitySGFacilitatorChart',
    label: 'Facilitator Feedback Chart',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
